import Group from "../../store/Group";

export default class GroupWithUsers extends Group {
    constructor(id, name, validatorGroupStrategy, users) {
        super(id, name);
        this.validatorGroupStrategy = validatorGroupStrategy;
        this.users = users;
    }

    countOfUserWithEnabledAccess() {
        let counter = 0;
        for (let i = 0; i < this.users.length; i++) {
            if (this.users[i].active) {
                counter++;
            }
        }
        return counter;
    }

    countOfUsers() {
        return this.users.length;
    }
}


// WEBPACK FOOTER //
// ./web/js/groupManagement/entities/GroupWithUsers.js